// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing {
  background: white;
}

.pricing__header {
  text-align: center;
  margin-bottom: 64px;
}

.pricing__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 32px;
  margin-bottom: 80px;
}

.pricing-card {
  background: white;
  border: 2px solid var(--border-color);
  border-radius: 16px;
  padding: 32px;
  position: relative;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}

.pricing-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.pricing-card--popular {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
}

.pricing-card__badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 600;
}

.pricing-card__header {
  margin-bottom: 32px;
}

.pricing-card__name {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--text-primary);
}

.pricing-card__description {
  font-size: 14px;
  color: var(--text-secondary);
  margin-bottom: 24px;
}

.pricing-card__price {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.price-amount {
  font-size: 48px;
  font-weight: 800;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.price-period {
  font-size: 16px;
  color: var(--text-secondary);
}

.pricing-card__features {
  flex-grow: 1;
  margin-bottom: 32px;
}

.pricing-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  font-size: 15px;
  color: var(--text-primary);
}

.pricing-check {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(99, 102, 241, 0.1);
  color: var(--primary-color);
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}

.btn--block {
  width: 100%;
  justify-content: center;
}

.pricing__faq {
  max-width: 800px;
  margin: 0 auto;
}

.faq-title {
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 48px;
  color: var(--text-primary);
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.faq-item {
  padding: 24px;
  background: var(--bg-secondary);
  border-radius: 12px;
}

.faq-item h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--text-primary);
}

.faq-item p {
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .pricing__grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .pricing-card {
    padding: 24px;
  }

  .price-amount {
    font-size: 36px;
  }

  .faq-title {
    font-size: 28px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Pricing/Pricing.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,iFAAiF;EACjF,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iFAAiF;EACjF,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".pricing {\r\n  background: white;\r\n}\r\n\r\n.pricing__header {\r\n  text-align: center;\r\n  margin-bottom: 64px;\r\n}\r\n\r\n.pricing__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 32px;\r\n  margin-bottom: 80px;\r\n}\r\n\r\n.pricing-card {\r\n  background: white;\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 16px;\r\n  padding: 32px;\r\n  position: relative;\r\n  transition: all 0.3s;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.pricing-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n.pricing-card--popular {\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);\r\n}\r\n\r\n.pricing-card__badge {\r\n  position: absolute;\r\n  top: -12px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  color: white;\r\n  padding: 6px 16px;\r\n  border-radius: 50px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.pricing-card__header {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.pricing-card__name {\r\n  font-size: 24px;\r\n  font-weight: 700;\r\n  margin-bottom: 8px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pricing-card__description {\r\n  font-size: 14px;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.pricing-card__price {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 4px;\r\n}\r\n\r\n.price-amount {\r\n  font-size: 48px;\r\n  font-weight: 800;\r\n  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.price-period {\r\n  font-size: 16px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.pricing-card__features {\r\n  flex-grow: 1;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.pricing-feature {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 12px 0;\r\n  font-size: 15px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.pricing-check {\r\n  width: 24px;\r\n  height: 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(99, 102, 241, 0.1);\r\n  color: var(--primary-color);\r\n  border-radius: 50%;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.btn--block {\r\n  width: 100%;\r\n  justify-content: center;\r\n}\r\n\r\n.pricing__faq {\r\n  max-width: 800px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.faq-title {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  text-align: center;\r\n  margin-bottom: 48px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.faq-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.faq-item {\r\n  padding: 24px;\r\n  background: var(--bg-secondary);\r\n  border-radius: 12px;\r\n}\r\n\r\n.faq-item h4 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 8px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.faq-item p {\r\n  font-size: 15px;\r\n  line-height: 1.6;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .pricing__grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 24px;\r\n  }\r\n\r\n  .pricing-card {\r\n    padding: 24px;\r\n  }\r\n\r\n  .price-amount {\r\n    font-size: 36px;\r\n  }\r\n\r\n  .faq-title {\r\n    font-size: 28px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
